import { useCallback, memo, useEffect, useState } from 'react';
import { BzButton, BzModal, BzModalHeader, BzModalBody, BzModalFooter } from '../components';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal } from '../redux/actions/modals';
import { userLogout } from '../redux/actions/auth';
import { getAppInfoData } from '../utils/global_functions';
import { API_ERRORS, APP_INFO_PARAMS, LOCAL_STORAGE_KEYS } from '../utils/global_variables';

const GuestUserRestrictionModal = () => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state.modals.modals);
    const appInfo = useSelector(state => state.appInfo.appInfo);
    const { objLoginSession } = useSelector(state => state.auth);
    const [eKYCInfo, setEKYCInfo] = useState({});
    //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
    useEffect(() => {
        if (appInfo?.length) {
            const data = getAppInfoData(APP_INFO_PARAMS.APP_EKYC_INFO, appInfo);
            if (objLoginSession?.errors === API_ERRORS.ECODE_ACC_SUSPENDED) {
                if (data?.reekycurl && data?.ekyctext) {
                    setEKYCInfo(data);
                }
                else { setEKYCInfo({}); }
            }
            else {
                if (data?.ekycurl && data?.ekyctext) {
                    setEKYCInfo(data);
                }
                else { setEKYCInfo({}); }
            }
        }
    }, [appInfo, objLoginSession]);
    //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End

    //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
    const handleClickBtn = useCallback((e, type) => {
        e?.preventDefault();
        switch (type) {
            case 'login':
                dispatch(userLogout()).then(() => {
                    // Ameersha N : 28-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
                    localStorage?.removeItem(LOCAL_STORAGE_KEYS.ACCEPTED_NOTICES_ID);
                    // Ameersha N : 28-11-2023 : BT-116461 Breeze - Addendum and Notices --End
                    window.location.replace('/');
                }).catch(() => {
                    // Ameersha N : 28-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
                    localStorage?.removeItem(LOCAL_STORAGE_KEYS.ACCEPTED_NOTICES_ID);
                    // Ameersha N : 28-11-2023 : BT-116461 Breeze - Addendum and Notices --End
                    window.location.replace('/?param1=guestLogin');
                });
                localStorage?.removeItem(LOCAL_STORAGE_KEYS.GUEST_TOAST);
                break;
            case 'register':
                let path = '/register';

                if (Object?.keys(eKYCInfo)?.length > 0 && eKYCInfo?.ekycurl?.length > 0) {
                    path = eKYCInfo?.ekycurl;
                    window?.open(`${path}`, '_blank');
                } else {
                    dispatch(userLogout()).then(() => {
                        window.location.replace('/register');
                    }).catch(() => {
                        window.location.replace('/register');
                    });
                    localStorage?.removeItem(LOCAL_STORAGE_KEYS.GUEST_TOAST);
                    localStorage?.removeItem(LOCAL_STORAGE_KEYS.GUEST_USER);
                }
                break;
            case 'skip':
                dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": false }]));
                break;

            default:
                break;
        }
    }, [dispatch, eKYCInfo]);

    const handleCancelModal = () => {
        dispatch(handleModal([{ 'GUEST_USER_RESTRICTION_MODAL': false }]));
    };

    //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End
    return (
        <BzModal size='md' show={modals['GUEST_USER_RESTRICTION_MODAL']} onHide={handleCancelModal} onExiting={handleCancelModal}>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex flex-row justify-content-start align-items-start'>
                            <div className='icon-20 icon-lock icon-dark me-2'></div>
                            <div className='font-medium font-size4 color-text'>This Feature is Locked</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={handleCancelModal}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0 mt-2 mb-3'>
                        <Col className='d-flex justify-content-start'>
                            <div className='font-regular font-size4 color-text'>
                                This feature is currently not avilable for Guest Users. Kindly Register or Login with us to access the same
                            </div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0 justify-content-end'>
                        <Col md={2}>&nbsp;</Col>
                        <Col md={10}  className='d-flex align-items-end align-items-end gap-2'>                            
                            <BzButton className='btn btn-md btn-block btn-outline' onClick={(e) => handleClickBtn(e, 'skip')}>Skip</BzButton>
                            <BzButton className='btn btn-md btn-block btn-primary' onClick={(e) => handleClickBtn(e, 'login')}>Login</BzButton>
                            <BzButton className='btn btn-md btn-block btn-primary' onClick={(e) => handleClickBtn(e, 'register')}>Register</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    );
};

export default memo(GuestUserRestrictionModal);